import { Type } from 'class-transformer';

// @dynamic
export class RelToObjectColumnMapping {
    Source: string;
    Target: string;
    IsList = false;
    IsCommaSeparated = true;
    Separator = ',';
    SimpleListType: string;
    ListID: string[] = [];
    IsObject = false;
    @Type(() => RelToObjectColumnMapping)
    ObjectMappings: RelToObjectColumnMapping[] = [];
}

// @dynamic
export class RelToObjectSettingsData {
    UseTable = true;
    DataModel: string;
    DataSource: string;
    ExistingStructure: string;
    ContainerInternalID: string;
    @Type(() => RelToObjectColumnMapping)
    Mappings: RelToObjectColumnMapping[] = [];
}
